import AdyenCCBuyNow from './adyen-cc-buy-now';

export default AdyenCCBuyNow;
